<div class="politicas-grid-wrapper">
  <table class="politicas-table">
    <thead>
      <tr>
        <th class="politicas-th-comuna">Comuna / Pallets</th>
        <th *ngFor="let key of columnKeys; trackBy: trackByColumn" class="politicas-th-col">
          {{ columnLabel(key) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackByRow">
        <td class="politicas-td-comuna">{{ row.comuna }}</td>
        <td *ngFor="let cell of row.cells; trackBy: trackByCell" class="politicas-td-cell">
          <button
            type="button"
            class="btn cell-chip"
            [class.cell-chip--filled]="cell.hasValue"
            [class.cell-chip--empty]="!cell.hasValue"
            (click)="onCellSelected(cell)"
            [attr.title]="cell.hasValue ? cell.horas + ' h — ' + cell.centro : 'Agregar'"
          >
            <ng-container *ngIf="cell.hasValue; else vacioTpl">
              <span class="cell-chip__stack">
                <span class="cell-chip__line cell-chip__line--num">{{ cell.horas }}</span>
                <span class="cell-chip__line cell-chip__line--code">{{ cell.centro }}</span>
              </span>
            </ng-container>
            <ng-template #vacioTpl>
              <i class="bi bi-plus cell-chip__icon" aria-hidden="true"></i>
            </ng-template>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
